import { FC } from 'react';

import { Box } from '@components';

import { StyledGradient, StyledLabel } from './MapLegend.styles';
import { MapLegendProps } from './MapLegend.types';
import { getEqIntervals } from '../../../../../utils/maps';

import './MapLegend.css';

const DEFAULT_HEIGHT = '200px';
const DEFAULT_WIDTH = '50px';

const DEFAULT_SCALE_HEIGHT = '100%';
const DEFAULT_SCALE_WIDTH = '12px';

const MapLegend: FC<MapLegendProps> = ({
  colors,
  height = DEFAULT_HEIGHT,
  labelBottom,
  labelTop,
  scaleHeight = DEFAULT_SCALE_HEIGHT,
  scaleWidth = DEFAULT_SCALE_WIDTH,
  width = DEFAULT_WIDTH,
}) => {
  let scaleBackground;
  if (colors) {
    const gradientPercentages = getEqIntervals([0, 100], colors.length, 0, 100);
    colors.map((c: string, i: number) => `${c} ${gradientPercentages[i]}`);

    scaleBackground = `linear-gradient(
    to top,
    ${colors.join(',')}
    )`;
  }

  return (
    <>
      <StyledGradient css={{ width, height }}>
        <StyledLabel data-testid="legend-label-top">{labelTop}</StyledLabel>
        <Box css={{ background: scaleBackground, height: scaleHeight, width: scaleWidth }}></Box>
        <StyledLabel data-testid="legend-label-bottom">{labelBottom}</StyledLabel>
      </StyledGradient>
    </>
  );
};
export default MapLegend;
